const isValidDate = (d) => d instanceof Date && !Number.isNaN(d);

export default isValidDate;
